import { render } from "./delete_button.vue?vue&type=template&id=0255f487&lang=pug"
import script from "./delete_button.vue?vue&type=script&lang=js"
export * from "./delete_button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__